"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _menu = require("../utils/menu");
var _deleteRequester = _interopRequireDefault(require("./deleteRequester"));
var _common = require("../utils/common");
var _constant = require("../constant");
var _lodash = require("lodash");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /* eslint-disable no-underscore-dangle */
/**
 * 数据管理的编辑扩展类
 */
var EditRequester = /*#__PURE__*/function (_DeleteRequester) {
  (0, _inherits2.default)(EditRequester, _DeleteRequester);
  var _super = _createSuper(EditRequester);
  function EditRequester(options, uuid) {
    var _this;
    (0, _classCallCheck2.default)(this, EditRequester);
    _this = _super.call(this, options, uuid);
    _this.uuidCacheObj = {};
    return _this;
  }

  /**
   * 编辑多条主表数据的table树数据
   * @param {*} newList 新的数据
   * @param {*} oldList 旧的数据
   */
  (0, _createClass2.default)(EditRequester, [{
    key: "editAllDataDetail",
    value: function () {
      var _editAllDataDetail = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(newList, oldList) {
        var i;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (oldList) {
                // 基于旧数据，得到一颗还原后包含数据的table树
                this.regainTableTreeByDataTree(oldList, this.tableTree);
              }
              // 基于新数据，得到diff后的所有数据变更状态的table树
              for (i = 0; i < newList.length; i++) {
                this.setChangeDataByTable(newList[i], this.tableTree);
              }

              // 对table树中不再引用的数据，优先递归解绑关联键值
              this.setNotDependDataByTable(this.tableTree);
              _context.next = 5;
              return this.saveDataForAdd();
            case 5:
              if (!(this.errMsg.length > 0)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              _context.next = 9;
              return this.saveDataForEdit();
            case 9:
              _context.next = 11;
              return this.saveDataForDelete();
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function editAllDataDetail(_x, _x2) {
        return _editAllDataDetail.apply(this, arguments);
      }
      return editAllDataDetail;
    }() // ---------------------------------------------
    /**
     * 对比指定table的一条数据变更状态，包括关联键值的更新(递归)
     * @param {*} newData 新数据
     * @param {*} table table实例
     * @param {*} parentRelationObj 当前table与父节点的关系
     * @param {*} parentData 关联的父节点数据
     */
  }, {
    key: "setChangeDataByTable",
    value: function setChangeDataByTable(newData, table, parentRelationObj, parentData) {
      var _this2 = this;
      // 返回处理基本字段变更后的数据对象
      var resultData = this.setBaseDataByDiff(newData, table);
      if (table.forkTableList.length > 0) {
        table.forkTableList.forEach(function (forkTableObj) {
          var relationObj = forkTableObj.relationObj;
          var _relationObj$relation = (0, _slicedToArray2.default)(relationObj.relation, 2),
            relation0 = _relationObj$relation[0],
            relation1 = _relationObj$relation[1];
          if (relation1 === _menu.RelationStatus.INCLUDE
          // link关联的键值在父表：会包含原有的关联键值，需要先一步清空重新绑定（新增的不考虑）
          && resultData.__changeType !== _menu.DataStatus.ADD) {
            _this2.setFieldData(resultData, relation0, '');
          }
        });
      }
      if (parentRelationObj && parentData) {
        // 说明非根节点，处理父子数据的关联键填充
        this.setRelationDataByDiff(resultData, parentRelationObj, parentData);
      }

      // 遍历子表的数据集，进行同样的处理（递归）
      table.forkTableList.forEach(function (forkTableObj) {
        var relationObj = forkTableObj.relationObj,
          forkTable = forkTableObj.forkTable;
        var newForkDataList = newData["".concat(_constant.TABLETAG).concat(forkTable.tableKey)] || [];
        // 1对1关系：挂的是对象形式，要转成数组处理
        if (!Array.isArray(newForkDataList)) {
          newForkDataList = [newForkDataList];
        }
        newForkDataList.forEach(function (forkData) {
          _this2.setChangeDataByTable(forkData, forkTable, relationObj, resultData);
        });
      });
    }

    /**
     * 记录当前节点的数据变更
     * @param {*} $newData 节点数据
     * @param {*} table 节点对应的table
     */
  }, {
    key: "setBaseDataByDiff",
    value: function setBaseDataByDiff($newData, table) {
      var dataList = table.dataList,
        primaryKey = table.primaryKey,
        rawPrimaryKey = table.rawPrimaryKey;
      var newData = $newData;
      var findData = dataList.find(function (oldData) {
        return oldData[primaryKey] === newData[primaryKey];
      });
      // 旧的数据已存在
      if (findData) {
        // 若变更了基础字段值，则记录编辑态
        var diffReslut = this.diffDataChange(newData, findData, table.schemaList);
        if (Object.keys(diffReslut).length > 0) {
          this.setEditState(findData, diffReslut);
        }
      } else {
        // 全新添加的数据
        if ((0, _common.noneValue)(newData[primaryKey])) {
          // 临时为其生成一个主键；避免等待异步的新增主键生成，再填充关联的键值（避免异步地狱）
          findData = (0, _common.cloneRawData)(newData);
          findData[primaryKey] = (0, _common.generateUUID)();
          // 为空说明是非自定义的主键，补上用于后续的关联填充
          if ((0, _common.noneValue)((0, _common.getValueByPath)(findData, rawPrimaryKey))) {
            (0, _common.setValueByPath)(findData, rawPrimaryKey, findData[primaryKey]);
          }
          findData.__changeType = _menu.DataStatus.ADD;
          dataList.push(findData);
          // 缓存这个对象，用于后续优先添加到无极
          this.uuidCacheObj[findData[primaryKey]] = {
            data: findData,
            table: table
          };
        } else {
          // 若主键已存在，是从已有的数据源中添加（同时又允许被二次修改）
          findData = (0, _common.cloneRawData)(newData);
          // 缺乏可diff原数据，当作全部字段修改
          var _diffReslut = this.diffDataChange(findData, {}, table.schemaList);
          if (Object.keys(_diffReslut).length > 0) {
            this.setEditState(findData, _diffReslut);
          }
          dataList.push(findData);
        }
      }
      findData.__isDepend = true; // 说明此条数据有被使用
      return findData;
    }

    /**
     * 更新父子节点数据的关联键值
     * @param {*} curData 当前节点的数据
     * @param {*} parentRelationObj 与父节点的关联键值数据
     * @param {*} parentData 父节点的数据
     */
  }, {
    key: "setRelationDataByDiff",
    value: function setRelationDataByDiff(curData, parentRelationObj, parentData) {
      var relation = parentRelationObj.relation;
      var parentValue = this.getFieldData(parentData, relation[0]);
      var curValue = this.getFieldData(curData, relation[2]);
      // 普通关联的键在子表
      if (relation[1] === _menu.RelationStatus.RIGHT) {
        this.setBaseRelationValue(curData, relation[2], parentValue);
      }
      // 普通关联的键在父表
      if (relation[1] === _menu.RelationStatus.LEFT) {
        this.setBaseRelationValue(parentData, relation[0], curValue);
      }
      // link关联的键在子表
      if (relation[1] === _menu.RelationStatus.IN) {
        this.setLinkRelationValue(curData, relation[2], parentValue);
      }

      // link关联的键在父表
      if (relation[1] === _menu.RelationStatus.INCLUDE) {
        this.setLinkRelationValue(parentData, relation[0], curValue);
      }
    }

    /**
     * diff单条数据是否变更，并收集变更字段
     */
  }, {
    key: "diffDataChange",
    value: function diffDataChange(newData, oldData, schemaList) {
      var changeFields = {};
      var fields = (schemaList === null || schemaList === void 0 ? void 0 : schemaList.fields) || [];
      fields.forEach(function (_ref) {
        var id = _ref.id;
        // 两个都是undefined，无需处理
        if (newData[id] === undefined && oldData[id] === undefined) {
          return;
        }
        if (newData[id] !== oldData[id]) {
          changeFields[id] = (0, _lodash.cloneDeep)(newData[id]);
        } else if (['string', 'number', 'boolean'].indexOf((0, _typeof2.default)(newData[id])) === -1 && newData[id] !== null) {
          // 强相等的，非基本类型的都算变更
          changeFields[id] = (0, _lodash.cloneDeep)(newData[id]);
        }
      });
      return changeFields;
    }

    /**
     * 补充上下表关系的关联键值时，同步标记数据的更新状态[link关联]
     * （承接上下文，此方法的data状态只会是未处理、ADD、EDIT）
     * @param {*} data
     * @param {*} key
     * @param {*} linkValue
     */
  }, {
    key: "setLinkRelationValue",
    value: function setLinkRelationValue(data, key, linkValue) {
      var getValue = this.getFieldData(data, key);
      var resultStr;
      if ((0, _common.noneValue)(getValue)) {
        resultStr = "".concat(linkValue);
      } else if ("".concat(getValue).split(_constant.LINKSPLIT).indexOf("".concat(linkValue)) === -1) {
        resultStr = "".concat(getValue).concat(_constant.LINKSPLIT).concat(linkValue);
      }
      if (resultStr) {
        if (data.__changeType === _menu.DataStatus.ADD) {
          (0, _common.setValueByPath)(data, key, resultStr);
        } else {
          this.setFieldData(data, key, resultStr);
        }
      }
    }

    /**
     * 补充上下表关系的关联键值时，同步标记数据的更新状态[普通关联]
     * @param {*} $data
     * @param {*} key
     * @param {*} newValue
     */
  }, {
    key: "setBaseRelationValue",
    value: function setBaseRelationValue(data, key, newValue) {
      var getValue = this.getFieldData(data, key);
      if (getValue !== newValue) {
        if (data.__changeType === _menu.DataStatus.ADD) {
          (0, _common.setValueByPath)(data, key, newValue);
        } else {
          this.setFieldData(data, key, newValue);
        }
      }
    }

    // ---------------------------------------------
    /**
     * 新建数据：内部生成的uuid主键，必须优先用无极api保存并替换
     */
  }, {
    key: "saveDataForAdd",
    value: function () {
      var _saveDataForAdd = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this3 = this;
        var uuidKeys, priorityUuidKeys, allPromise;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              uuidKeys = Object.keys(this.uuidCacheObj);
              if (!(uuidKeys.length === 0)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              if (uuidKeys.length > 1) {
                // 找出add数据：并未引用其他的uuid，则可优先调用无极api并添加
                priorityUuidKeys = uuidKeys.filter(function (key) {
                  var data = _this3.uuidCacheObj[key].data;
                  var otherUuidKeys = uuidKeys.filter(function (otherKey) {
                    return otherKey !== key;
                  });
                  var uuidRep = new RegExp("".concat(otherUuidKeys.join('|')));
                  return !uuidRep.test(JSON.stringify(data));
                });
              } else {
                priorityUuidKeys = uuidKeys;
              }
              if (!(priorityUuidKeys.length === 0)) {
                _context2.next = 6;
                break;
              }
              throw Error('saveDataForAdd failed');
            case 6:
              allPromise = [];
              priorityUuidKeys.forEach(function (key) {
                var _this3$uuidCacheObj$k = _this3.uuidCacheObj[key],
                  table = _this3$uuidCacheObj$k.table,
                  data = _this3$uuidCacheObj$k.data;
                var cloneData = (0, _common.cloneRawData)(data);
                // 说明是非自定义主键（上面自动赋值uuid的，只有新建的数据才有），uuid生成的提交时要先清空
                if ((0, _common.getValueByPath)(cloneData, table.rawPrimaryKey) === cloneData[table.primaryKey]) {
                  (0, _common.setValueByPath)(cloneData, table.rawPrimaryKey, undefined);
                }
                delete cloneData[table.primaryKey];
                var promiseAdd = table.dataApi.create(cloneData, {
                  uuid: _this3.uuid,
                  errMsg: _this3.errMsg
                }).then(function (primaryKey) {
                  if (primaryKey) {
                    _this3.replaceAllPrimaryKeyForUuid(key, primaryKey);
                  }
                });
                allPromise.push(promiseAdd);
                // 处理过的就删除
                delete _this3.uuidCacheObj[key];
              });
              // 等待这一批量处理完，再递归下一波
              _context2.next = 10;
              return (0, _common.allSettled)(allPromise);
            case 10:
              if (!(this.errMsg.length > 0)) {
                _context2.next = 12;
                break;
              }
              return _context2.abrupt("return");
            case 12:
              _context2.next = 14;
              return this.saveDataForAdd();
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function saveDataForAdd() {
        return _saveDataForAdd.apply(this, arguments);
      }
      return saveDataForAdd;
    }()
    /**
     * 对当前的table树的数据，全量的刷一遍替换uuid成primaryKey
     * @param {*} uuid
     * @param {*} primaryKey
     */
  }, {
    key: "replaceAllPrimaryKeyForUuid",
    value: function replaceAllPrimaryKeyForUuid(uuid, primaryKey) {
      function replaceData(data) {
        var resultStr = JSON.stringify(data).replace(new RegExp("".concat(uuid), 'g'), primaryKey);
        return Object.assign(data, JSON.parse(resultStr));
      }
      this.rawTableList.forEach(function (table) {
        // eslint-disable-next-line
        table.dataList = table.dataList.map(function (data) {
          if (data.__changeType === _menu.DataStatus.ADD || data.__changeType === _menu.DataStatus.EDIT) {
            return replaceData(data);
          }
          return data;
        });
      });
    }
  }]);
  return EditRequester;
}(_deleteRequester.default);
var _default = EditRequester;
exports.default = _default;